import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { CraneRequest } from '../../../core/data/models/crane-request.model';

@Injectable()
export class CraneService extends BaseCrudService<CraneRequest> {
  controller = 'Cranes';
}
